export default () => (
  <svg
    width="29"
    height="20"
    viewBox="0 0 29 20"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.7253 0.580831C26.9437 0.900429 27.9034 1.84212 28.2291 3.03799C28.821 5.20536 28.821 9.72759 28.821 9.72759C28.821 9.72759 28.821 14.2497 28.2291 16.4172C27.9034 17.6131 26.9437 18.5547 25.7253 18.8745C23.5167 19.4552 14.6605 19.4552 14.6605 19.4552C14.6605 19.4552 5.80423 19.4552 3.59568 18.8745C2.37723 18.5547 1.41754 17.6131 1.09184 16.4172C0.5 14.2497 0.5 9.72759 0.5 9.72759C0.5 9.72759 0.5 5.20536 1.09184 3.03799C1.41754 1.84212 2.37723 0.900429 3.59568 0.580831C5.80423 0 14.6605 0 14.6605 0C14.6605 0 23.5167 0 25.7253 0.580831ZM19.1661 9.72774L11.764 5.62176V13.8334L19.1661 9.72774Z"
      fill="inherit"
    />
  </svg>
);
